import React, {useEffect, useState} from "react";
import {isNotEmpty, isPresent, mayBe} from "./utils";
import {DocRow, DocTitle} from "../../components";
import {QRFooter} from "../qr_footer/QRFooter";
import {FlsegdResponse} from "../../types/flsegd";
import {DocTable} from "../../components/doc_table/DocTable";
import {DocumentsBatch} from "../../types";
import {selectedDocument} from "./index";
import {AvailableDocuments} from "./AvailableDocuments";


export const FlsegdDoc: React.FC<{ documents: DocumentsBatch, withVersions?: boolean }> = ({
                                                                                               documents,
                                                                                               withVersions = true
                                                                                           }) => {

    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
            {
                document: documents.documents[0],
                documentTypeName: documents.documentsType
            });

    const [doc, setDocument] = useState<FlsegdResponse>(
            selectedDocument.document.document as FlsegdResponse
    )

    useEffect(() => {
        setDocument(selectedDocument.document.document as FlsegdResponse);
    }, [selectedDocument.document.version]);

    return (
            <>
                <div className="col-span-12 md:col-span-12">
                    <DocTitle title={'Единый жилищный документ № б/н'} subtitle={'Выдана заявителю:'}
                              uid={doc.blockchainUid}/>
                </div>

                <div className="col-span-12 md:col-span-8">
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Фамилия" bold value={mayBe(doc.data.zayavLast)}/>
                        <DocRow title="Имя" bold value={mayBe(doc.data.zayavFirst)}/>
                        <DocRow title="Отчество" bold value={mayBe(doc.data.zayavMid)}/>
                        <DocRow title="Дата рождения" bold value={mayBe(doc.data.zayavBirthDt) || '-'}/>
                        <DocRow
                                title="Документ удостоверяющий личность"
                                bold
                                value={mayBe(doc.data.pass) || '-'}
                        />
                    </div>

                    {isNotEmpty(doc.data.prevPass) &&
                            <>
                                <DocTitle subtitle={'Сведения о ранее выданном(ых) паспорте(ах)'} title={''}/>
                                <div className="pl-3 pb-5 bottom-line">
                                    <DocRow title="Паспорт" bold value={doc.data.prevPass}/>
                                    <DocRow title="Причина замены паспорта" bold
                                            value={mayBe(doc.data.changeReason) || '-'}/>
                                </div>
                            </>
                    }
                </div>

                {
                        withVersions && documents.documents.length > 0 &&
                        <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-3">
                            <AvailableDocuments
                                    docs={documents}
                                    setSelectedDocument={setSelectedDocument}
                                    className={'md:-mt-12 mb-5'}
                            />
                        </div>
                }

                <div className="col-span-12 md:col-span-8 md:order-last">
                    {
                        doc.data.zayavOwnNoreg !== '1'
                                ? <DocTitle subtitle={'Заявитель зарегистрирован по месту жительства'} title={''}/>
                                : <DocTitle
                                        subtitle={'Заявитель является собственником жилого помещения без регистрации по адресу'}
                                        title={''}/>
                    }
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Адрес регистрации" bold value={mayBe(doc.data.addrstr)}/>
                        <DocRow title="Форма владения/собственности" bold value={mayBe(doc.partTypeList?.partType[0])}/>
                    </div>

                    {isNotEmpty(doc.data.serviceCompany) &&
                            <>
                                <DocTitle subtitle={'Жилищная организация, осуществляющая управление домом'}
                                          title={''}/>
                                <div className="pl-3 pb-5 bottom-line">
                                    <DocRow title="Наименование" bold value={doc.data.serviceCompany}/>
                                    <DocRow title="Адрес/Телефон" bold value={mayBe(doc.data.adrTelCompany) || '-'}/>
                                </div>
                            </>
                    }

                    {doc && doc.owners?.owner.length > 0 &&
                            <>
                                <DocTitle subtitle={'Лицевой счет открыт на:'} title={''}/>
                                <DocTable
                                        className={'doc-table--m0 bottom-line'}
                                        title={''}
                                        headers={[
                                            'ФИО',
                                            'Доля в праве собственности',
                                        ]}
                                        rows={doc.owners.owner.map(owner => [
                                            mayBe(owner.fio) || '-',
                                            mayBe(owner.ownPerc, '%') || '-',
                                        ])}
                                        empty={'-'}/>
                            </>
                    }

                    {doc && doc.docs?.doc?.length > 0 &&
                            <>
                                <DocTitle subtitle={'Документы на жилое помещение'} title={''}/>
                                <div className="pl-3 pb-5 bottom-line">
                                    {doc.docs.doc.map((d, i) =>
                                            <DocRow title="Документ"
                                                    key={i}
                                                    bold value={
                                                isPresent(d.name) ?? isPresent(d.who)
                                                        ? `${d.name} выдан ${d.who}`
                                                        : d.name}
                                            />)}
                                </div>
                            </>
                    }

                    <DocTitle subtitle={'Характеристики жилого помещения'} title={''}
                              className={'doc-title__subtitle--mt-'}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Количество комнат" bold
                                value={`${mayBe(doc.data.flatType) || '-'}
                                ${doc.data.kommun === '1'
                                        ? `${mayBe(doc.data.croomFlat, '-комнатная ')}
                                        ${isPresent(doc.data.roomCount) ? '(' + doc.data.roomCount + ' комн.)' : ''}`
                                        : mayBe(doc.data.roomCount, '-комнатная')}`}
                        />
                        <DocRow title="Жилое помещение расположено на этаже" bold value={mayBe(doc.data.floor) || '-'}/>
                        <DocRow title="Количество этажей" bold value={mayBe(doc.data.cfloor) || '-'}/>
                        <DocRow title="Год постройки" bold value={mayBe(doc.data.houseYear) || '-'}/>
                        <DocRow title="Серия" bold value={mayBe(doc.data.seria) || '-'}/>
                        <DocRow title="Материал стен" bold value={mayBe(doc.data.materialSten) || '-'}/>
                    </div>

                    <DocTitle subtitle={'Удобства'} title={''}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Лифт" bold value={mayBe(doc.data.lift) || '-'}/>
                        <DocRow title="Водопровод" bold value={mayBe(doc.data.cw) || '-'}/>
                        <DocRow title="Ванна" bold value={mayBe(doc.data.vanna) || '-'}/>
                        <DocRow title="Канализация" bold value={mayBe(doc.data.kanal) || '-'}/>
                        <DocRow title="Горячая водоснобжение" bold value={mayBe(doc.data.hw) || '-'}/>
                        <DocRow title="Тип системы ГВС" bold value={mayBe(doc.data.schemaHw) || '-'}/>
                        <DocRow title="Центральное отопление" bold value={mayBe(doc.data.centrOtopl) || '-'}/>
                        <DocRow title="Газоснабжение" bold value={mayBe(doc.data.gas) || '-'}/>
                    </div>

                    <DocTitle subtitle={'Площадь жилого помещения'} title={''}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Общая" bold value={mayBe(doc.data.sAll) || '-'}/>
                        <DocRow title="Жилая" bold value={mayBe(doc.data.sGil) || '-'}/>
                        <DocRow title="Жилая заним." bold value={mayBe(doc.data.sFlsGil) || '-'}/>
                        <DocRow title="Привед. площадь" bold value={mayBe(doc.data.sPriv) || '-'}/>
                        <DocRow title="Неотапл. площадь" bold value={mayBe(doc.data.sNeot) || '-'}/>
                        <DocRow title="Пл. летних помещ." bold value={mayBe(doc.data.sLet) || '-'}/>
                        <DocRow title="Общая с летн. пом." bold value={mayBe(doc.data.sAllLet) || '-'}/>
                        <DocRow title="Кухня" bold value={mayBe(doc.data.sKitchen) || '-'}/>
                        {
                                doc && doc?.rooms?.room
                                        .map((room) =>
                                                <DocRow key={room.roomid}
                                                        title={`${room.nom} ${room.roomPlan}`}
                                                        bold
                                                        value={mayBe(room.sRoom) || '-'}
                                                />)
                        }
                    </div>

                    <DocTitle subtitle={'В жилом помещении зарегистрированы по месту жительства'} title={''}/>
                    <DocTable
                            className={'doc-table--refdebt-services bottom-line'}
                            title={''}
                            headers={[
                                'ФИО, место рождения, дата рождения',
                                'Родственные отношения',
                                'Документ удостоверяющий личность',
                                'Пред. документ удостоверяющий личность',
                                'Когда и откуда прибыл',
                                'Когда и куда выбыл',
                            ]}
                            rows={doc?.people?.man
                                    ?.filter(p => p.regType !== '0')
                                    .map(p => [
                                        `${mayBe(p.fio, ',')} ${mayBe(p.birthLocation, ',')} ${mayBe(p.birthDate)}`,
                                        mayBe(p.relType) || '-',
                                        mayBe(p.passport) || '-',
                                        mayBe(p.passportPrior) || '-',
                                        `${mayBe(p.regDate, p.regFrom) || '-'}`,
                                        `${mayBe(p.outDate, p.outWhere) || '-'}`,
                                    ])}
                            empty={''}
                    />

                    <DocTitle
                            subtitle={'Наличие мер социальной поддержки (льготы) по оплате жилого помещения и коммунальных услуг'}
                            title={''}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Наличие субсидии" bold value={mayBe(doc.data.subs) || '-'}/>
                        <DocRow title={`Задолженность по оплате жилого помещения и коммунальных услуг на ${doc.data.period} г.`}
                                bold value={isPresent(doc?.dolgPer?.periods[0]?.serv) ? 'имеется' : 'не имеется'}/>
                    </div>


                    {
                            doc.data.kommun === '1' &&
                            <>
                                <DocTitle
                                        subtitle={'Дополнительно проживают/зарегистрированы в жилом помещении (для квартир коммунального заселения) (указывается общее количество человек и характеристика занимаемых комнат):'}
                                        title={''}/>
                                <DocTable
                                        className={'doc-table--refdebt-services bottom-line'}
                                        title={''}
                                        headers={[
                                            '№ комнаты',
                                            'Характеристика комнаты',
                                            'Приведенная площадь',
                                            'Жилая площадь',
                                            'Количество человек',
                                        ]}
                                        rows={doc.rooms.room
                                                .filter(room => room.flsid !== doc.data.flsId)
                                                .map(room => [
                                                    mayBe(room.nom) || '-',
                                                    mayBe(room.roomPlan) || '-',
                                                    mayBe(room.sRoom) || '-',
                                                    mayBe(room.sRoomAll) || '-',
                                                    mayBe(room.cmanReg) || '-',
                                                ])}
                                        empty={''}
                                />
                            </>
                    }
                    <QRFooter blockchainUid={doc.blockchainUid}
                              refDate={doc.data.curdate}
                              mfcInfoName={doc.data.firmName}
                              mfcUserName={doc.data.userName}
                    />
                </div>
            </>
    )
            ;
};
